import React, { useEffect, useState } from 'react'
import type { UploadProps } from 'antd'
import { message, Upload } from 'antd'
import { CloudUploadOutlined } from '@ant-design/icons'
import { API_URLs } from '../../configuration/api-urls'
import { globalConfig } from '../../configuration/config'
import { decryptIdToken } from '../../pages/constants'

const DragAndDrop: React.FC<{ bulkUploadRequests: string }> = ({
  bulkUploadRequests,
}) => {
  const [idToken, setIdToken] = useState<string | null>(null)
  const { Dragger } = Upload

  useEffect(() => {
    const fetchDecryptedToken = async () => {
      const decryptedToken = await decryptIdToken()
      setIdToken(decryptedToken)
    }

    fetchDecryptedToken()
  }, [])

  const props: UploadProps = {
    name: 'file',
    multiple: true,
    maxCount: 1,
    action: globalConfig
      .get()
      .apiBaseUrl.concat(
        bulkUploadRequests === 'requests'
          ? API_URLs.v1.POST_RequestBulkUpload
          : API_URLs.v1.POST_BulkUpload
      ),
    onChange(info) {
      const { status } = info.file

      if (status == 'uploading') {
      }

      if (status !== 'uploading') {
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`)
      } else if (status === 'error') {
        if (info.file.error[0]?.description) {
          message.error(
            `${info.file.error[0].field} ${info.file.error[0].description}  File upload failed.`
          )
        } else {
          message.error('File upload failed')
        }
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files)
    },
    beforeUpload: (file) => {
      const isExcel =
        file.type ===
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      if (!isExcel) {
        message.error(`${file.name} is not a (XLSX or XLS) file`)
      }
      return isExcel || Upload.LIST_IGNORE
    },

    customRequest: async (options) => {
      const formData = new FormData()

      formData.append(options.filename, options.file)

      try {
        const response = await fetch(options.action, {
          method: 'POST',
          body: formData,
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        })

        if (response.ok) {
          const responseData = await response.json()
          options.onSuccess(responseData, options.file)
        } else {
          const errorData = await response.json()
          //message.error(`${response.status} ${response.statusText}`)
          console.log(`${response.status} ${response.statusText}`)
          options.onError(errorData, options.file)
        }
      } catch (error: any) {
        options.onError(error, options.file)
        console.log('error', error)
      }
    },
  }

  return (
    <div>
      <Dragger {...props} listType="picture">
        <p className="ant-upload-drag-icon">
          <CloudUploadOutlined className="!text-component-green" />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibited from
          uploading sensitive data or other banned files.
        </p>
      </Dragger>
    </div>
  )
}

export default DragAndDrop
